class ResolutionHelper {
  static getResolutionFromScale(scale) {
    if (scale == null || scale == undefined || scale < 0) throw "Skala nie może być pusta lub mniejsza od 0";
    const devicePixelRatio = window ? window.devicePixelRatio : 1;
    return 1 / (1 / scale * ResolutionHelper._inchesPerMeter * ResolutionHelper._baseDPI * devicePixelRatio);
  }
}

ResolutionHelper._inchesPerMeter = 39.37;
ResolutionHelper._baseDPI = 96;

export default ResolutionHelper;